
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contest/[contestUuid]/game/[sport]/player-one-and-done/picks",
      function () {
        return require("private-next-pages/contest/[contestUuid]/game/[sport]/player-one-and-done/picks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contest/[contestUuid]/game/[sport]/player-one-and-done/picks"])
      });
    }
  